/**
 * Aktualizuje CSS třídu elementu 'data-match-meta-status-update' podle stavu zápasu.
 * CSS třída: 'detail-match-overview-meta__match-status--... (sched | live | fin)'.
 *
 * @param matchElement - HTMLElement - zápas, který má být aktualizován.
 *                       Obashuje element s data atributem 'data-top-event-meta-status-update a třídu match-overview-meta__match-status--... (sched | live | fin)
 * @param matchStatus - stav zápasu (např. 'live', 'fin', ...)
 * @param sport - název sportu (např. 'fot', 'hok', 'haz', 'ten', 'bas', 'vol', 'flo', 'bab', 'fut', 'hob', 'sob','mot')
 */
export const updateTopEventMetaStatus = (
  matchElement: HTMLElement | null,
  matchStatus: string
): void => {
  if (!matchElement) return;

  const matchStatusElement = matchElement.querySelector<HTMLElement>(
    '[data-top-event-meta-status-update]'
  );
  if (!matchStatusElement) {
    console.warn('Element s [data-top-event-meta-status-update] nebyl nalezen.');
    return;
  }

  if (
    matchStatusElement.classList.contains('detail-match-overview-meta__match-status--sched') &&
    matchStatus === 'live'
  ) {
    // Prepnutie statusu do 'live'
    matchStatusElement.classList.remove('detail-match-overview-meta__match-status--sched');
    matchStatusElement.classList.add('detail-match-overview-meta__match-status--live');

    matchStatusElement.innerHTML = `<span class="typography typography--uppercase typography--body2-bold">Live</span><span class="detail-match-overview-meta__match-status-live-icon"></span>`;
  } else if (['fin', 'retired'].includes(matchStatus)) {
    // Prepnutie statusu do 'fin'
    matchStatusElement.classList.remove('detail-match-overview-meta__match-status--live');
    matchStatusElement.classList.add('detail-match-overview-meta__match-status--fin');

    matchStatusElement.innerHTML = '<span class="typography typography--meta-bold">Konec</span>';
  }
};
